import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { setSelectedShapeFilter, setSelectedShapes } from 'store/actions';
import { makeStyles } from '@material-ui/styles';
import SearchIcon from '@material-ui/icons/Search';
import { IconButton, Paper, Toolbar } from '@material-ui/core';

function PossibleShapesFilter({
  shapesData,
  shapesGeoType,
  selectedShapeFilter,
  setSelectedShapeFilter,
  setSelectedShapes,
  shapesColoringType,
}) {
  const classes = useStyles();

  const onFilterValueLowChanged = (e) => {
    const newFilter = {
      ...selectedShapeFilter,
      filterValueLow: e.target?.value ?? '',
    };

    setSelectedShapeFilter(newFilter);
  };

  const onFilterValueHighChanged = (e) => {
    const newFilter = {
      ...selectedShapeFilter,
      filterValueHigh: e.target?.value ?? '',
    };

    setSelectedShapeFilter(newFilter);
  };

  const onSearchClicked = () => {
    const { filterValueLow, filterValueHigh } = selectedShapeFilter;

    const filteredShapes = shapesData.filter((shape) => {
      const shapeFieldName = shape[shapesColoringType];
      let isWithinRange = true;

      if (filterValueLow && shapeFieldName < parseInt(filterValueLow)) {
        isWithinRange = false;
      }

      if (filterValueHigh && shapeFieldName > parseInt(filterValueHigh)) {
        isWithinRange = false;
      }

      return isWithinRange;
    });

    const mappedShapes = filteredShapes.map((shape) => ({
      id: shape.Geo,
      level: shapesGeoType,
    }));

    setSelectedShapes(mappedShapes);
  };

  return (
    <Paper className={classes.container}>
      <Toolbar variant={'dense'}>
        Low:
        <input
          style={{ width: 50, marginLeft: 5, marginRight: 5 }}
          type='text'
          value={selectedShapeFilter.filterValueLow}
          onChange={onFilterValueLowChanged}
        />
        High:
        <input
          style={{ width: 50, marginLeft: 5 }}
          type='text'
          value={selectedShapeFilter.filterValueHigh}
          onChange={onFilterValueHighChanged}
        />
        <IconButton size='medium' onClick={onSearchClicked}>
          <SearchIcon />
        </IconButton>
      </Toolbar>
    </Paper>
  );
}

// == Styles ====================================

const useStyles = makeStyles({
  container: {
    marginLeft: 10,
  },
});

// == Connect ==================================

const mapStateToProps = ({ assumptionMapState }) => ({
  shapesData: assumptionMapState.shapesData,
  shapesGeoType: assumptionMapState.shapesGeoType,
  shapesColoringType: assumptionMapState.shapesColoringType,
  selectedShapeFilter: assumptionMapState.selectedShapeFilter,
});

const mapDispatchToProps = {
  setSelectedShapeFilter,
  setSelectedShapes,
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(PossibleShapesFilter);